import React from 'react';
import { any } from 'prop-types';
import './SubInfo.scss';

const SubInfo = ({ children }) => {
    return (
        <div className="subinfo">
            {React.Children.map(children, (child, index) => {
                if (!child) {
                    return null;
                }
                return React.cloneElement(child, {
                    index: index
                });
            })}
        </div>
    );
};
SubInfo.propTypes = {
    children: any
};

export default SubInfo
